module.exports = __webpack_public_path__ + "static/media/product-image-3-add.042aac74.png";


//////////////////
// WEBPACK FOOTER
// ./src/routes/home/components/howToFeature/product-image-3-add.png
// module id = 269
// module chunks = 0